/**
 * Registry of column IDs that require custom rendering in the DAG table.
 * This centralizes the mapping so DagCellRenderer doesn't need scattered if-checks.
 */

/** Column IDs that use cascading hierarchy dropdowns */
export const HIERARCHY_COLUMN_IDS = new Set([
  'division',
  'department',
  'class',
  'subclass',
])

/** Maps column ID to its hierarchy level for the dropdown */
export const HIERARCHY_LEVEL_MAP: Record<
  string,
  'division' | 'department' | 'class' | 'subclass'
> = {
  division: 'division',
  department: 'department',
  class: 'class',
  subclass: 'subclass',
}
